import { TabOption } from "../../../shared/components/FormTabHeader";
import { BaseEntity } from "../../../shared/models/ApiModels";

export interface IReturnedCarModel extends BaseEntity{
    id: string
    endDate: Date
    endTime: string
    customerFullName: string
    carPlate: string
    returnBranchName: string
}

export interface IDepartureCarModel extends BaseEntity{
    id: string
    startDate: Date
    startTime: string
    customerFullName: string
    carPlate: string
    departureBranchName: string
}

export interface IBranchStatisticsModel {
    branchName: string
    fleet: number
    availableCar: number
    rented: number
    inMaintenance: number
    occupancyRate: number
    returnsToday: number
    departures: number
    departuresToday: number
    outgoingReservations: number
    returns: number
    baf: number
    forSale: number
}

export interface IGeneralStatusModel {
    rentedCount: number
    todayDepartures: number
    todayReturns: number
    todayExpectedReturns: number
    tomorrowExpectedReturns: number
    lateReturns: number
    abuse: number
    futureReservations: number
    todayExpectedDepartures: number
    tomorrowExpectedDepartures: number
    todayCancellations: number
    inContractToday: number
    noPlateReservations: number
    webClosedCars: number
    officeReservationClosedCars: number
    inspectionDue: number
    insuranceDue: number
    cascoDue: number
    bafCars: number
    agingCars: number
    endingToday: number
    serviceOperations: number
    pendingRequests: number
    deliverToService: number
    pickFromService: number
    serviceAging: number
}

export const dashboardTabs: TabOption<'short' | 'park' | 'detail'>[] = [
  {key: 'short', title: 'Kısa Yollar'},
  {key: 'park', title: 'Otopark Durumu'}, 
  {key: 'detail', title: 'Araç Detayları'}, 
]